import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "mx-2 my-4" }
const _hoisted_2 = { class: "card grid grid-cols-12 w-full p-4 mb-2 justify-items-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-white" }, "Handle", -1)
const _hoisted_4 = { class: "col-span-8 place-self-end text-right text-white font-bold text-xl" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "col-span-8 flex" }
const _hoisted_7 = { class: "w-8" }
const _hoisted_8 = { class: "col-span-2 flex justify-center text-center" }
const _hoisted_9 = { class: "w-8" }
const _hoisted_10 = {
  key: 2,
  class: "flex justify-center"
}
const _hoisted_11 = { class: "col-span-2 place-self-end" }


    import { orderBy } from 'lodash';
    import { useCoEStore } from './../../stores/CoEStore';
    import { useRouter } from 'vue-router';
    
    import CoalitionFlag from '@/components/CoalitionFlag/coalitionFlag.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'pilotRatingList',
  props: ['label', 'pilots', 'country', 'order', 'scorelabel'],
  setup(__props) {

const props = __props;

    
    const coeStore = useCoEStore();
    const router = useRouter();

    const navigate = (id) => {
        router.push('pilot/' + id)
    }


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, _toDisplayString(props.label) + " " + _toDisplayString(props.scorelabel), 1)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(orderBy)(props.pilots, props.order, 'desc').slice(0, 10), (pilot, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "flex flex-col w-full",
        key: `${pilot.Id}_${props.order}_${index}`
      }, [
        _createElementVNode("div", {
          class: "card grid grid-cols-12 w-full p-4 mb-2 justify-items-start hover:bg-gray-800",
          onClick: () => navigate(pilot.UserId)
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(index + 1) + ".", 1),
            _createTextVNode(" " + _toDisplayString(pilot.Handle), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (pilot.PreferedCoalition == 1)
                ? (_openBlock(), _createBlock(CoalitionFlag, {
                    key: 0,
                    country: "101"
                  }))
                : _createCommentVNode("", true),
              (pilot.PreferedCoalition == 2)
                ? (_openBlock(), _createBlock(CoalitionFlag, {
                    key: 1,
                    country: "201"
                  }))
                : _createCommentVNode("", true),
              (pilot.PreferedCoalition == 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _createVNode(CoalitionFlag, { country: "101" }),
                    _createVNode(CoalitionFlag, { country: "201" })
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(coeStore).formatRating(pilot[props.order])), 1)
        ], 8, _hoisted_5)
      ]))
    }), 128))
  ]))
}
}

})